import { CONTROL } from '../../../../components';
import { getObs, UnitsOfCalculationItem } from '../../../utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var StorageClassItem = {
  Performance: 'Performance',
  Standard: 'Standard',
  StandardEnhanced: 'Standard-Enhanced',
  PerformanceEnhanced: 'Performance-Enhanced'
};
var storageClassItems = [{
  value: StorageClassItem.Standard,
  label: 'Standard',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["150 M\u0411/\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041C\u0430\u043A\u0441. IOPS \u2014 5000; ", /*#__PURE__*/_jsx("br", {}), "\u0412\u0440\u0435\u043C\u044F \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438: 2-5 \u043C\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041E\u0431\u044A\u0435\u043C \u043E\u0442 500 \u0413\u0411 \u0434\u043E 32 \u0422\u0411"]
  })
}, {
  value: StorageClassItem.Performance,
  label: 'Performance',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["300 M\u0411/\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041C\u0430\u043A\u0441. IOPS \u2014 20 000; ", /*#__PURE__*/_jsx("br", {}), "\u0412\u0440\u0435\u043C\u044F \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438: 1-2 \u043C\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041E\u0431\u044A\u0435\u043C \u043E\u0442 500 \u0413\u0411 \u0434\u043E 32 \u0422\u0411"]
  })
}, {
  value: StorageClassItem.StandardEnhanced,
  label: 'Standard-Enhanced',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["1 \u0413\u0411/\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041C\u0430\u043A\u0441. IOPS \u2014 15 000; ", /*#__PURE__*/_jsx("br", {}), "\u0412\u0440\u0435\u043C\u044F \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438: 2-5 \u043C\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041E\u0431\u044A\u0435\u043C \u043E\u0442 10 \u0422\u0411 \u0434\u043E 320 \u0422\u0411"]
  })
}, {
  value: StorageClassItem.PerformanceEnhanced,
  label: 'Performance-Enhanced',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["2 \u0413\u0411/\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041C\u0430\u043A\u0441. IOPS \u2014 100 000; ", /*#__PURE__*/_jsx("br", {}), "\u0412\u0440\u0435\u043C\u044F \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438: 1-2 \u043C\u0441; ", /*#__PURE__*/_jsx("br", {}), "\u041E\u0431\u044A\u0435\u043C \u043E\u0442 10 \u0422\u0411 \u0434\u043E 320 \u0422\u0411"]
  })
}];
export var SCALABLE_FILE_FORM_CONFIG = {
  ui: ['storageClass', ['storage']],
  controls: {
    storageClass: {
      type: CONTROL.Carousel,
      defaultValue: StorageClassItem.Standard,
      items: storageClassItems,
      accessorKey: 'sfs.storageClass',
      decoratorProps: {
        label: 'Класс хранилища'
      },
      onChangeFn: function onChangeFn(value, setValue) {
        var arr = [['sfs.storageClass', value], ['sfs.storage.unitsOfCalculation', UnitsOfCalculationItem.Gb]];
        switch (value) {
          case StorageClassItem.StandardEnhanced:
          case StorageClassItem.PerformanceEnhanced:
            {
              arr.push(['sfs.storage.space', 10240]);
              break;
            }
          case StorageClassItem.Standard:
          case StorageClassItem.Performance:
          default:
            {
              arr.push(['sfs.storage.space', 500]);
              break;
            }
        }
        setValue(arr);
      }
    },
    storage: getObs({
      space: {
        accessorKey: 'sfs.storage.space',
        label: 'Размер хранилища',
        defaultValue: 500,
        uiProps: {
          min: 500,
          max: 32768,
          postfix: 'ГБ',
          showHint: true
        },
        watchedControls: {
          storageClass: 'sfs.storageClass',
          specification: 'sfs.storage.unitsOfCalculation'
        },
        relateFn: function relateFn(_ref) {
          var storageClass = _ref.storageClass,
            specification = _ref.specification;
          if (specification === 'tb') {
            if ([StorageClassItem.StandardEnhanced, StorageClassItem.PerformanceEnhanced].includes(storageClass)) {
              return {
                uiProps: {
                  min: 10,
                  max: 320,
                  postfix: 'ТБ'
                }
              };
            }
            return {
              uiProps: {
                min: 1,
                max: 32,
                postfix: 'ТБ'
              }
            };
          }
          if ([StorageClassItem.StandardEnhanced, StorageClassItem.PerformanceEnhanced].includes(storageClass)) {
            return {
              uiProps: {
                min: 10240,
                max: 327680,
                postfix: 'ГБ'
              }
            };
          }
        }
      },
      units: {
        accessorKey: 'sfs.storage.unitsOfCalculation',
        defaultValue: 'gb',
        onChangeFn: function onChangeFn(value, setValue) {
          var arr = [['sfs.storage.unitsOfCalculation', value]];
          if (value === UnitsOfCalculationItem.Tb) {
            arr.push(['sfs.storage.space', 1]);
          }
          setValue(arr);
        }
      }
    })
  }
};